import { createFileRoute } from '@tanstack/react-router';
import { AuthorizationParams, AppState } from '@auth0/auth0-react';

export type LoginSearch = {
  appState?: AppState;
  authorizationParams?: AuthorizationParams;
};

export const Route = createFileRoute('/_public/login')({
  validateSearch: (search: Record<string, unknown>): LoginSearch => ({
    appState: search.appState as AppState,
    authorizationParams: search.authorizationParams as AuthorizationParams,
  }),
  beforeLoad: async ({ search, context: { auth0 } }) => {
    const { appState, authorizationParams } = search;

    const { loginWithRedirect } = auth0;
    const defaultReturnTo = '/';

    const opts = {
      appState: {
        returnTo: defaultReturnTo,
        ...appState,
      },
      authorizationParams,
    };

    loginWithRedirect(opts);
  },
});
